import { styled, Typography } from '@bluedolphin/ui';

export const AvatarInitial = styled(Typography)({
    display: 'inline-block',
    height: '40px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '40px',
    backgroundColor: 'rgba(189, 189, 189, 1)',
    borderRadius: '50%',
    letterSpacing: '0.14px',
    fontWeight: '400',
    color: '#ffffff',
});
